import request from '@/utils/request'

let prefetchPromise = null

/**
 * 启动知识库首页预取（分类 + 推荐专题），用于改善 /kb 的 LCP。
 * 在应用启动且用户已登录时调用。
 */
export function startKbPrefetch() {
  if (prefetchPromise != null) return
  prefetchPromise = Promise.all([
    request.get('/kb/categories').then((data) => data).catch(() => null),
    request.get('/kb/series', { params: { current: 1, size: 6, recommended: true } }).then((data) => data).catch(() => null)
  ]).then(([categoriesRes, seriesRes]) => ({
    categories: Array.isArray(categoriesRes) ? categoriesRes : (categoriesRes && categoriesRes.records ? categoriesRes.records : []),
    recommendedSeries: Array.isArray(seriesRes?.records) ? seriesRes.records : []
  })).catch(() => null)
}

/**
 * 取走预取结果（仅能消费一次），kb/Index 挂载时调用。
 * @returns {Promise<{ categories: any[], recommendedSeries: any[] } | null>}
 */
export function takePrefetchedKb() {
  const p = prefetchPromise
  prefetchPromise = null
  return p || Promise.resolve(null)
}
